var map = {
	"./2gis-black.svg": 9064,
	"./2gis-black_active.svg": 1997,
	"./2gis.svg": 3418,
	"./2gis_active.svg": 8855,
	"./arrow.svg": 7190,
	"./arrow_active.svg": 3771,
	"./arrow_small.svg": 5434,
	"./arrow_small_active.svg": 3431,
	"./leftArrow.svg": 8759,
	"./leftArrow_active.svg": 5472,
	"./logo_active.svg": 1535,
	"./logo_black.svg": 3374,
	"./logo_mobile.svg": 7543,
	"./logo_mobile_active.svg": 240,
	"./rightArrow.svg": 3886,
	"./rightArrow_active.svg": 9667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9946;